import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';
import Sanitize      from '@utils/sanitize';

import ContentsModal from 'contents_modal';

import { Fade } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css'
// -------------------------------------------------------

class DraftPreviewModal extends React.Component {
  render() {
    if( this.props.view == false ) return null;
    
    let detail   = this.props.detail;
    let media    = this.props.media;
    let contents = this.props.contents;
    
    let thumbnail = '';
    try { thumbnail = media[0].media_url; } catch(e) {}
    
    // キャプション
    let caption = null;
    try { if( contents.caption != undefined && contents.caption != null ) caption = Sanitize.nl2br(contents.caption); } catch(e) {}
    
    let _html = <div>メディアが見つかりません</div>
    if( thumbnail != '' ){
      _html = (
        <div className="modal-item draft-preview-modal">
          <div className="left-thumbnail">
            { (media.length <= 1)
              ? <div className="image-single">
                  {(thumbnail != null) ? (Utils.isVideo(thumbnail) ? <video controls src={thumbnail} /> : <img src={thumbnail} />) : null }
                </div>
              : <Fade autoplay={false} indicators={true} transitionDuration={100}>
                  { media.map((d, key) => {
                    return(
                      <div className="each-slide" key={key}>
                        {(Utils.isVideo(d.media_url)) ? <video controls src={d.media_url} /> : <img src={d.media_url} /> }
                      </div>
                    );
                  })}
                </Fade>
            }
          </div>
          <div className="right-caption">
            <div dangerouslySetInnerHTML={{ __html: caption }} />
          </div>
        </div>
      );
    }
    
    return (
      <ContentsModal
        view      = {this.props.view}
        width     = {'calc(100% - 200px)'}
        height    = {550}
        max_width = {800}
        close_ev  = {this.props.close_ev.bind(this, false)}
        html      = {_html}
      />
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default DraftPreviewModal;